import React, { useState } from "react";
import "./My_order_card.css";
import Lottie from "react-lottie";
import * as animationData from "./SuccessStatus.json";
import { Table } from "react-bootstrap";
import OrangeFilledRoundBtn from "../Common_Btn/OrangeFilledRoundBtn/OrangeFilledRoundBtn";
import YellowFilledRoundBtn from "../Common_Btn/YellowFilledRoundBtn/YellowFilledRoundBtn";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleUp } from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

function My_order_card({ val }) {
  const [isActive, setIsActive] = useState(false);

  const toggleActiveClass = () => {
    setIsActive(!isActive);
  };

  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: animationData,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };

  const productSpecifications = [
    { label: "Card Type", value: "Translucent Card - Rounded corner" },
    { label: "Orientation", value: "Landscape" },
    { label: "Materials", value: "Translucent Card (185 micron Thick Card)" },
    { label: "Shape and Size", value: "Rectangle (3.5 x 2 in)" },
    { label: "Orientation", value: "Portrait" },
  ];

  function formatDate(dateString) {
    const date = new Date(dateString);

    // Format: "5 Feb 2025"
    const options = { day: "numeric", month: "short", year: "numeric" };
    const formattedDate = date.toLocaleDateString("en-GB", options); // Example: "5 Feb 2025"

    // Calculate yesterday's date
    const today = new Date();
    const yesterday = new Date(today);
    yesterday.setDate(today.getDate() - 1);

    // Compare if the date is yesterday
    const isYesterday =
      date.getDate() === yesterday.getDate() &&
      date.getMonth() === yesterday.getMonth() &&
      date.getFullYear() === yesterday.getFullYear();

    return isYesterday ? `Yesterday, ${formattedDate}` : formattedDate;
  }

  return (
    <section className="My_order_card">
      <div className="row">
        {/* Product Image Section */}
        <div className="col-md-2 col-sm-3 col-6">
          <div className="product_img_holder">
            <img
              src={
                process.env.REACT_APP_IMG_URL +
                val?.Product?.Product_Images[0]?.image
              }
              className="product_img"
              alt="product_img"
            />
          </div>
        </div>

        {/* Product Details Section */}
        <div className="col-md-10 col-sm-9 ">
          <div className="card_inner_content">
            <div className="heading_status_holder">
              <div className="heading_holder">
                <h3>(Job ID: {val?.job_id})</h3>
              </div>
              <div className="status_lottie_holder">
                {val?.order_status_id === 1 && (
                  <Lottie className="status_lottie" options={defaultOptions} />
                )}
              </div>
            </div>

            {/* Order Table */}
            <div className="main_table_holder">
              <div className="subtitle_holder">
                <h3 onClick={toggleActiveClass} style={{ cursor: "pointer" }}>
                  {val?.Product?.name}{" "}
                  <FontAwesomeIcon
                    className={`us_arrow ${isActive ? "active" : ""}`}
                    icon={faAngleUp}
                  />
                </h3>
              </div>
              <div className="row">
                <div className="col-lg-9">
                  <div className="heading_table_holder">
                    <div className="info_table_holder">
                      <Table responsive>
                        <thead>
                          <tr>
                            <th>Quantity</th>
                            <th>Order Status</th>
                            <th>Placed On</th>
                            {val?.order_status_id === 5 && (
                              <th>Delivery Date</th>
                            )}

                            <th>Item total</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>{val?.quantity}</td>
                            <td className="text_green">
                              {val?.OrderStatus?.name}
                            </td>
                            <td>{formatDate(val?.createdAt)}</td>
                            {val?.order_status_id === 5 && (
                              <td>{formatDate(val?.updatedAt)}</td>
                            )}
                            <td className="text_red">₹{val?.total}</td>
                          </tr>
                        </tbody>
                      </Table>
                    </div>
                  </div>
                </div>

                {/* Action Buttons */}
                <div className="col-lg-3 d-lg-block d-flex justify-content-center mt-lg-0 mt-3">
                  <div className="btn_holder mb-2">
                    <Link to={`/job-details/${val?.id}`}>
                      <YellowFilledRoundBtn btnText={"Job Details"} />
                    </Link>
                  </div>
                  <Link to={`/re-order/${val?.Product?.id}`}>
                    <div className="btn_holder">
                      <OrangeFilledRoundBtn btnText={"Re Order"} />
                    </div>
                  </Link>
                </div>
              </div>
            </div>
          </div>

          {/* Product Specifications (Initially Hidden) */}
          {isActive && (
            <div className="card_inner_content card_inner_content_two">
              <div className="main_table_holder">
                <div className="semiSubtitle_holder">
                  <h3>Product Specifications</h3>
                </div>
                <div className="row">
                  <div className="col-md-12">
                    <div className="heading_table_holder">
                      <div className="info_table_holder">
                        <Table responsive>
                          <tbody>
                            {val?.Product_Combination?.round_corner && (
                              <tr>
                                <td>Card Type</td>
                                <td> Rounded corner</td>
                              </tr>
                            )}
                            {val?.Product_Combination?.Orientation && (
                              <tr>
                                <td>Orientation</td>
                                <td>
                                  {val?.Product_Combination?.Orientation.name}
                                </td>
                              </tr>
                            )}
                            {val?.Product_Combination?.Material && (
                              <tr>
                                <td>Material</td>
                                <td>
                                  {val?.Product_Combination?.Material.name}
                                </td>
                              </tr>
                            )}
                            {val?.Product_Combination?.Size && (
                              <tr>
                                <td>Size</td>
                                <td>{val?.Product_Combination?.Size.name}</td>
                              </tr>
                            )}
                            {val?.Product_Combination?.Lamination && (
                              <tr>
                                <td>Lamination</td>
                                <td>
                                  {val?.Product_Combination?.Lamination.name}
                                </td>
                              </tr>
                            )}
                            {val?.Product_Combination?.Envelope && (
                              <tr>
                                <td>Envelope</td>
                                <td>
                                  {val?.Product_Combination?.Envelope.name}
                                </td>
                              </tr>
                            )}
                            {val?.Product_Combination?.PrintingLocation && (
                              <tr>
                                <td>Print</td>
                                <td>
                                  {
                                    val?.Product_Combination?.PrintingLocation
                                      .name
                                  }
                                </td>
                              </tr>
                            )}
                            {val?.Product?.Shape && (
                              <tr>
                                <td>Shape</td>
                                <td>{val?.Product?.Shape.name}</td>
                              </tr>
                            )}
                          </tbody>
                          {/* <tbody>
                            {productSpecifications.map((spec, index) => (
                              <tr key={index}>
                                <td>{spec.label}</td>
                                <td>{spec.value}</td>
                              </tr>
                            ))}
                          </tbody> */}
                        </Table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </section>
  );
}

export default My_order_card;
